import React, {useState} from 'react';
import $api, {API_URL} from "../../http";
import ModalDialog from "../ModalDialog";
import ModalImgViewer from "./ModalImgViewer";
import {addDevidersToString, downloadHandler} from "./helper-functions";

const TraderAppealTable = ({appeals, processing, closeAppeal}) => {

    const [activeModal, setActiveModal] = useState("no")
    const [modalMessage, setModalMessage] = useState("")
    const [activeNoPayModal, setActiveNoPayModal] = useState("no")
    const [activeActualAmountModal, setActiveActualAmountModal] = useState("no")

    const [activeTraderConfirmModal, setActiveTraderConfirmModal] = useState("no")

    const [activeImgModal, setActiveImgModal] = useState("no")
    const [imgSrc, setImgSrc] = useState("")

    const [currentAppeal, setCurrentAppeal] = useState()
    const [actualAmount, setActualAmount] = useState()


    const [progress, setProgress] = useState(0)
    const [loading, setLoading] = useState(false)



    // async function downloadHandler(path, setLoading, setProgress) {
    //
    //     console.log(path)
    //
    //
    //     setLoading(true)
    //     setProgress(0); // Сбрасываем прогресс
    //
    //     // const response = await $api.get(`/download_file?path=${path}`, {responseType: 'arraybuffer'})
    //
    //
    //     const response = await $api.get(`/download_file?path=${encodeURIComponent(path)}`, {
    //         responseType: 'arraybuffer',
    //         onDownloadProgress: (progressEvent) => {
    //             const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //             setProgress(percentCompleted);
    //         },
    //     });
    //
    //     setLoading(false)
    //     console.log(response.data)
    //
    //     //создаем блоб (Binary Large OBject) из ответа
    //     const blob = new Blob([response.data], { type: 'application/octet-stream' });
    //     //const blob = await response.blob()
    //     //из него генерируем ссылку на файл
    //     const downloadURL = URL.createObjectURL(blob)
    //     //создаем элемент ссылки
    //     const link = await document.createElement('a')
    //     //назначаем элементу собственно ссылку
    //     link.href = downloadURL
    //
    //     //это тоже всё еще назначение ссылки (тут добавляется имя файла)
    //     const filenameWindows = path.substring(path.lastIndexOf("\\") + 1).replace(/_/g, " ");
    //     let filename;
    //
    //     if (filenameWindows.includes('/')) {
    //         filename = filenameWindows.split('/').pop().replace(/_/g, " ");
    //     } else {
    //         filename = filenameWindows.replace(/_/g, " ");
    //
    //     }
    //
    //     link.download = filename
    //
    //     //добавляем то что создали в ДОМ
    //     document.body.appendChild(link)
    //     //кликаем
    //     link.click()
    //     //и избавляемся от элемента
    //     link.remove()
    //     URL.revokeObjectURL(downloadURL)
    // }


    function validateInputActualAmount(input) {
        // Регулярное выражение для чисел, начинающихся не с 0
        // const validPattern = /^(10|[0-9](\.\d+)?|0\.[1-9]+)?$/;
        const validPattern = /^$|^[1-9]\d*(?:[.,]\d+)?$/;

        const valid = validPattern.test(input);

        if (valid) {
            setActualAmount(input);
        }
    }



    const noPayment = async (appealId, scam) => {
        const response = await $api.post('/appeal_no_payment', {appealId, scam})

        console.log(response.data)


    }


    const setActualAmountToAppeal = async (appealId, actualAmount) => {


        const response = await $api.post('/appeal_set_actual_amount', {appealId, actualAmount})

        console.log(response.data)


    }



    return (

        appeals.length
            ?
            // <div className={"transaction-table-wrapper"}>
            <div style={{overflowX: 'auto', width: '100%' }}>
            <table className="transaction-table">
                    <thead>
                    <tr>
                        <th>Дата</th>
                        <th>Номер</th>
                        <th>Заявка</th>
                        {/*<th>Мерчант</th>*/}
                        {/*<th>Трейдер</th>*/}
                        <th>Сумма (руб)</th>
                        <th>Решение</th>
                        <th>Инфо</th>
                        <th>Актуальная сумма</th>
                        <th>Чек</th>

                        <th className={"fixed-table-width"}>Управление</th>

                    </tr>
                    </thead>
                    <tbody>
                    {appeals.length
                        ?
                        appeals?.map((appeal, index) => {
                            // const formattedDate = new Date(card.block_timestamp)
                            //     .toLocaleString('ru-RU', options);

                            return (
                                <tr
                                    key={appeal._id}
                                    className={
                                        appeal.status === "pending" && !appeal.traderReaction
                                            ?
                                            "red-row"
                                            :
                                            appeal.status === "pending" && appeal.traderReaction
                                                ?
                                                "green-row"
                                                :
                                                index % 2 === 0
                                                    ?
                                                    'even-row'
                                                    :
                                                    'odd-row'

                                    }
                                >
                                    <td>{new Date(appeal.created_at).toLocaleString([], {
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric",
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}</td>
                                    <td>{appeal.number}</td>
                                    <td>{appeal.order?.number}</td>
                                    {/*<td>{appeal.merchant?.login}</td>*/}
                                    {/*<td>{appeal.trader?.login}</td>*/}
                                    <td>{appeal.amount}</td>
                                    <td>{appeal.resolution}</td>
                                    <td>{appeal.traderDescription}</td>
                                    <td>{appeal.actualAmount}</td>
                                    <td className={`${Array.isArray(appeal.receipt) && appeal.receipt.length > 0 ? "flex-table-cell-column"  : ""}`}>
                                        {Array.isArray(appeal.receipt) && appeal.receipt.length > 0 &&
                                            appeal.receipt.map((file, index) => (
                                                <button
                                                    key={index}
                                                    className="gradient-orange-button show-check-btn"
                                                    onClick={async () => {
                                                        const lowerFile = file.toLowerCase();
                                                        const isPdf = lowerFile.endsWith(".pdf");
                                                        const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
                                                        const isImage = imageExtensions.some(ext => lowerFile.endsWith(ext));

                                                        if (isPdf) {
                                                            const fileUrl = `${API_URL}/${file}`;
                                                            window.open(fileUrl, "_blank");
                                                            return;
                                                        }

                                                        if (isImage) {
                                                            setActiveImgModal("progress");
                                                            setTimeout(() => {
                                                                setActiveImgModal("active");
                                                            }, 100);
                                                            setImgSrc(file);
                                                            return;
                                                        }

                                                        // Всё остальное — скачивание
                                                        await downloadHandler(file, setLoading, setProgress);
                                                    }}
                                                >
                                                    {(() => {
                                                        const lowerFile = file.toLowerCase();
                                                        const isPdf = lowerFile.endsWith(".pdf");
                                                        const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
                                                        const isImage = imageExtensions.some(ext => lowerFile.endsWith(ext));
                                                        const isDownload = !isPdf && !isImage;

                                                        if (isDownload) {
                                                            return loading ? `Скачать ${progress}%` : "Скачать";
                                                        }

                                                        return appeal.receipt.length > 1 ? `Показать ${index + 1}` : "Показать";
                                                    })()}
                                                </button>

                                                // <button
                                                //     key={index}
                                                //     className="gradient-orange-button show-check-btn"
                                                //     onClick={() => {
                                                //         console.log(file);
                                                //         if (file.toLowerCase().endsWith(".pdf")) {
                                                //             const fileUrl = `${API_URL}/${file}`;
                                                //             window.open(fileUrl, "_blank");
                                                //             return;
                                                //         }
                                                //         setActiveImgModal("progress");
                                                //         setTimeout(() => {
                                                //             setActiveImgModal("active");
                                                //         }, 100);
                                                //         setImgSrc(file);
                                                //     }}
                                                // >
                                                //     {appeal.receipt.length > 1 ? `Показать ${index + 1}` : "Показать"}
                                                // </button>
                                            ))
                                        }
                                    </td>
                                    <td>
                                        {appeal.status !== "closed" && !appeal.traderDescription
                                            ?
                                            <button
                                                className={"gradient-orange-button"}
                                                onClick={() => {

                                                    setCurrentAppeal(appeal)
                                                    setActiveModal("progress")
                                                    setTimeout(() => {
                                                        setActiveModal("active")
                                                    }, 100)

                                                }}
                                            >
                                            Реакция
                                            </button>
                                            :
                                            null
                                        }
                                    </td>

                                </tr>
                            );
                        })
                        :
                        null
                    }
                    </tbody>


                </table>
                <ModalDialog
                    active={activeModal}
                    setActive={setActiveModal}
                    action={() => {
                        setActiveTraderConfirmModal("progress")
                        setTimeout(() => {
                            setActiveTraderConfirmModal("active")
                        }, 100)
                    }}
                    action2={() => {
                        setActiveNoPayModal("progress")
                        setTimeout(() => {
                            setActiveNoPayModal("active")
                        }, 100)
                    }}
                    message={`Есть платёж на ${addDevidersToString(currentAppeal?.amount)} р. по заявке №${currentAppeal?.order.number} ?`}
                    purpose={"pay_choice"}
                    buttonText2={"Нет"}
                />
                <ModalDialog
                    active={activeTraderConfirmModal}
                    setActive={setActiveTraderConfirmModal}
                    action={() => {
                        closeAppeal(currentAppeal._id)
                    }}
                    message={`Вы уверены что хотите закрыть апелляцию #${currentAppeal?.number} в пользу клиента?`}
                    purpose={"choice"}

                />
                <ModalDialog
                    active={activeNoPayModal}
                    setActive={setActiveNoPayModal}
                    action={() => {
                        noPayment(currentAppeal._id)
                    }}
                    action2={() => {

                        setActiveNoPayModal("progress")
                        setTimeout(() => {
                            setActiveNoPayModal("no")
                        }, 100)

                        setActiveActualAmountModal("progress")
                        setTimeout(() => {
                            setActiveActualAmountModal("active")
                        }, 100)
                    }}
                    action3={() => noPayment(currentAppeal._id, true)}
                    message={`Какой из этих случаев ваш?`}
                    purpose={"no_pay_choice"}

                />
                <ModalImgViewer
                    active={activeImgModal}
                    setActive={setActiveImgModal}
                    imgSrc={imgSrc?.replace(/\\/g, "/")}
                    setImgSrc={setImgSrc}
                />
                <ModalDialog
                    active={activeActualAmountModal}
                    setActive={setActiveActualAmountModal}
                    purpose={"input"}
                    inputType={"number"}
                    message={`Введите актуальную сумму для апелляции #${currentAppeal?.number}`}
                    inputValue={actualAmount}
                    setInputValue={validateInputActualAmount}
                    buttonText1={"Подтвердить"}
                    action={() => setActualAmountToAppeal(currentAppeal._id, actualAmount)}

                />

            </div>
            :
            processing
                ?
                <img src={require('../../img/loading.gif')} height={"40px"}
                     className={"margin-left-20"}/>
                :
                <h2>Нет ничего соответствующего вашему запросу</h2>






    );
};

export default TraderAppealTable;